import { Card, Col, Form, Input, Row, Space } from 'antd';
import Title from 'antd/lib/typography/Title';
import { useFormikContext } from 'formik';
import { SparingRequestPayload } from 'models/SparingRequests';
import { useGetSparingRequestConfigurationTypesQuery } from 'redux/services/calvin/sparingRequestConfigTypes';
import { colors, toRgba } from 'styles/colors';

export const DefectiveReturnsHeader = (): JSX.Element => {
  const { values, setFieldValue } = useFormikContext<SparingRequestPayload>();
  // DefectiveReturnsTable holds back its first sync of defectiveReturns until the request types have
  // loaded, and with the requirement off that sync resets these contact fields. So these inputs are
  // not rendered until then either - otherwise a value typed in that window would be wiped by it.
  const { isLoading: isRequestTypesLoading } = useGetSparingRequestConfigurationTypesQuery();

  return (
    <Card
      headStyle={{ backgroundColor: toRgba(colors.illuminatingEmerald, 0.4) }}
      title={
        <Row justify="space-between">
          <Col>
            <Title level={4} style={{ fontWeight: 'normal' }}>
              Defective Return Responsible Party
            </Title>
          </Col>
        </Row>
      }
      loading={isRequestTypesLoading}
      style={{ height: '100%' }}>
      <Row gutter={[0, 10]}>
        <Col span={24}>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Space style={{ width: '100%' }} direction="vertical">
                <Form layout="vertical">
                  <Form.Item label="Contact Name">
                    <Input
                      size="large"
                      style={{ width: '100%' }}
                      value={values.defectiveReturns?.contactName ?? ''}
                      onChange={(e): void => {
                        setFieldValue('defectiveReturns.contactName', e.target.value);
                      }}
                    />
                  </Form.Item>
                  <Form.Item label="Contact Phone Number">
                    <Input
                      size="large"
                      style={{ width: '100%' }}
                      type="tel"
                      value={values.defectiveReturns?.contactPhoneNumber ?? ''}
                      onChange={(e): void => {
                        setFieldValue('defectiveReturns.contactPhoneNumber', e.target.value);
                      }}
                    />
                  </Form.Item>
                  <Form.Item label="Contact Email">
                    <Input
                      size="large"
                      style={{ width: '100%' }}
                      type="email"
                      value={values.defectiveReturns?.contactEmail ?? ''}
                      onChange={(e): void => {
                        setFieldValue('defectiveReturns.contactEmail', e.target.value);
                      }}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};
